import { s3NoCacheRequestClientUtil } from '../../main/utils/clients/s3.client.util.ts';

import { EnvironmentType } from '../types/environment.types.ts';

interface Props {
  url: string;
}

export const getEnvironmentDataRequest = async ({ url }: Props): Promise<EnvironmentType | null> => {
  const response = await s3NoCacheRequestClientUtil.get<EnvironmentType>(url).catch(() => undefined);
  return response?.data ?? null;
};
